import React, {Component} from 'react'
import OrderLabelPage from './OrderLabelPage'
import '../styles/index.scss'

class OrderLabelPageContainer extends Component {
    render() {
        return (
            <div className='OrderLabelPageContainer Huge'>
                <div className='container-fluid min-vh-100 bg-white shadow-sm'>
                    <div className='row'>
                        <div className='col'>
                            <OrderLabelPage/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OrderLabelPageContainer
